import * as React from "react";
import { useMediaQuery } from "react-responsive";
import { Grid } from "../../grid/grid/grid.mjs";
import { useTheme } from "../../helpers/theme-provider/use-theme.mjs";
const ServiceCards = (props) => {
  const { className, children } = props;
  const [itemsInRow, setItemsInRow] = React.useState(children.length);
  const { media } = useTheme();
  const isScreenSmallerThanSm = useMediaQuery({
    maxWidth: media.width.xs.max
  });
  const isScreenSmallerThanXl = useMediaQuery({
    maxWidth: media.width.lg.max
  });
  const ref = React.useRef(null);
  const innerRef = React.useRef(null);
  const BEM = () => {
    const classArray = ["service-cards", "service-cards--items-".concat(itemsInRow)];
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  const updateDimensions = () => {
    var _a, _b, _c;
    const element = ref.current;
    const innerElement = innerRef.current;
    const containerWidth = (_a = element == null ? void 0 : element.clientWidth) != null ? _a : 0;
    const cardItemWidth = (_c = (_b = innerElement == null ? void 0 : innerElement.firstElementChild) == null ? void 0 : _b.getBoundingClientRect().width) != null ? _c : 152;
    const totalCardItemsWidth = cardItemWidth * children.length;
    const firstRowCardItemsWidth = cardItemWidth * Math.ceil(children.length / 2);
    if (totalCardItemsWidth < containerWidth) {
      setItemsInRow(children.length);
      if (isScreenSmallerThanXl && children.length > 4) {
        setItemsInRow(Math.ceil(children.length / 2));
      }
    } else if (firstRowCardItemsWidth < containerWidth) {
      setItemsInRow(Math.ceil(children.length / 2));
      if (isScreenSmallerThanSm && children.length > 4) {
        setItemsInRow(3);
      }
    } else {
      setItemsInRow(2);
    }
  };
  React.useEffect(() => {
    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => {
      window.removeEventListener("resize", updateDimensions);
    };
  });
  return /* @__PURE__ */ React.createElement("div", { className: BEM(), ref }, /* @__PURE__ */ React.createElement(Grid, { equalHeight: true, element: "ul", className: "service-cards__inner", align: ["start-xs"], gridRef: innerRef }, children));
};
export {
  ServiceCards
};
